const style: any = (): any => {
	return {
		
		toggleButtonLifecycle: {
			padding: "7px 16.4px",
			height: 36,
			borderRadius: 0,
			marginLeft: "0px !important",
			backgroundColor: "#FFFF",
			border: 0,
			fontSize: 14,
			color: "#242c34 !important",
			fontWeight: "medium" as const,
			textTransform: "none" as const,
		},
		toggleButtonGroup: {
			display: "inline-block",
			borderRadius: 2,
			border: "1px solid #d0d5da",
		},
		selectedButton: {
			borderRadius: 2,
			border: "1px solid #3a91e8 !important",
			backgroundColor: "#f0f8ff !important",
			boxShadow: "0px 1px 4px 0px rgba(21, 118, 214, 0.15)",
		},
		toggleButton: {
			marginLeft: "0px !important",
			borderRadius: 0,
			padding: "7px 17px",
			backgroundColor: "#FFFF",
			height: 36,
			border: 0,
			fontSize: 14,
			color: "#242c34 !important",
			fontWeight: "normal" as const,
			textTransform: "none" as const,

		},
	};
};

export default style;